import {
  RatingConfigurator,
  CommentConfigurator
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const EscWebuiUPCampaignFeedbackSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'EscWebuiUPCampaignFeedbackSurvey',
    style: {
      root: {
        minWidth: 600,
        '@media (max-width: 600px)': {
          minHeight: 320,
          minWidth: 340,
        },
      },
    },
    others: {
      isGlobalModalStyleEnabled: true,
      isThankYouPageEnabled: false,
      isUserInitiatedSurvey: true,
      combineTextInputToComment: true,
      isInPageMiddle: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('Congratulations on successfully publishing your first campaign! Please rate your experience.')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Extremely easy')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Somewhat easy')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neither easy nor difficult')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Somewhat difficult')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Extremely difficult')),
          rating: 0.2,
        },
      ],
    },
    questions: [
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q0',
        page: 0,
        position: 1,
        getTitle: () => i18n.getString(_TL_('Additional feedback (optional)')),
        placeholder: i18n.getString(_TL_('Please don\'t include any confidential or personal information.')),
        isVisible: () => true,
      },
    ],
  };
};
